import { Box, Checkbox, Typography, Grid } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBox, Info } from "@material-ui/icons";
import { Fragment } from "react";
import { Disclaimer, SchemeData } from ".";
import Image from "../../../Image";
import { CartItemProps } from "../useInvestorCart";
import { CartItem, CartItemsMap } from "../../../../store/types";
import {
  convertDate,
  convertDateToIndian,
  convertToInr,
  getDescriptiveDate,
} from "../../../../utils/cart";
import { isSameDay } from "date-fns";

export const SipCartItem: CartItemProps<"ISIP"> = function (props) {
  const {
    isSelected,
    payload,
    cartId,
    cartItemId,
    editCartItem,
    fundCode,
    removeCartItem,
    selectCartItem,
  } = props;

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            checked={isSelected}
            onChange={() => selectCartItem(cartItemId)}
            style={{ color: "#2057A6" }}
          />
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
            }}
          >
            {payload.schemeName}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            padding: "10px",
          }}
        >
          <Image
            src="/images/edit_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => editCartItem(cartId, cartItemId, fundCode)}
          />
          <Image
            src="/images/delete_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => removeCartItem(cartId, cartItemId)}
          />
        </Box>
      </Box>

      <Grid container style={{ padding: "12px" }}>
        <Grid item xs={12} lg={9}>
          <Grid container>
            <SchemeData name="SIP Day" value={payload.sipDay} />
            <SchemeData
              name="No. of Installments"
              value={payload.noOfInstallments}
            />
            <SchemeData
              name="Start Date"
              value={convertDate(payload.sipStartDate)}
            />
            <SchemeData
              name="End Date"
              value={convertDate(payload.sipEndDate)}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={3}>
          <SchemeData
            name="SIP"
            value={convertToInr(payload.installmentAmount)}
          />
          {!!payload.amount ? (
            <SchemeData name="Lumpsum " value={convertToInr(payload.amount)} />
          ) : null}
        </Grid>
      </Grid>
    </Fragment>
  );
};

interface UpdatedSipSummary
  extends React.FC<{
    cartItem: CartItem<"SIN">["payload"];
    updatedCartItem: CartItem<"SIN">["payload"];
  }> {}

export const UpdatedCartItem: UpdatedSipSummary = function (props) {
  const { cartItem: oldCartItem, updatedCartItem } = props;

  const { sipStartDate: oldStartDate, sipEndDate: oldEndDate } = oldCartItem;
  const { sipStartDate, sipEndDate } = updatedCartItem;

  const isSameDate =
    isSameDay(new Date(oldStartDate), new Date(sipStartDate)) &&
    isSameDay(new Date(oldEndDate), new Date(sipEndDate));

  if (isSameDate) {
    return <SipSummaryItem {...updatedCartItem} />;
  }

  const [d1, oldD1, d2, oldD2] = [
    sipStartDate,
    oldStartDate,
    sipEndDate,
    oldEndDate,
  ]
    .map(getDescriptiveDate)
    .map((d) => <strong>{d}</strong>);

  return (
    <Fragment>
      <SipSummaryItem {...updatedCartItem} />
      <Typography>
        Your SIP Startdate have been changed from {oldD1} to {d1} and SIP
        Enddate have been changed from {oldD2} to {d2}
      </Typography>
    </Fragment>
  );
};

export const SipSummaryItem = function (payload: CartItemsMap["ISIP"]) {
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px",
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
            }}
          >
            {payload.schemeName}
          </Typography>
        </Box>
      </Box>

      <Grid container style={{ padding: "12px" }}>
        <Grid item xs={12} lg={9}>
          <Grid container>
            <SchemeData name="SIP Day" value={payload.sipDay} />
            <SchemeData
              name="No. of Installments"
              value={payload.noOfInstallments}
            />
            <SchemeData
              name="Start Date"
              value={convertDateToIndian(payload.sipStartDate)}
            />
            <SchemeData
              name="End Date"
              value={convertDateToIndian(payload.sipEndDate)}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={3}>
          <SchemeData
            name="SIP"
            value={convertToInr(payload.installmentAmount)}
          />
          {!!payload.amount && (
            <SchemeData name="Lumpsum" value={convertToInr(payload.amount)} />
          )}
        </Grid>
      </Grid>
      <Grid></Grid>
      {payload.isFreedom ? (
        <Fragment>
          <Box display="flex" alignItems="center">
            <Info color="primary" />
            <Typography
              variant="caption"
              style={{
                padding: "8px",
                fontWeight: "bold",
                color: "#033f7c",
              }}
            >
              You have opted for Prosperity SIP
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px",
            }}
          >
            <Box display="flex" alignItems="center">
              <Typography
                style={{
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                }}
              >
                {payload.swpSchemeName}
              </Typography>
            </Box>
          </Box>
          <Grid container style={{ padding: "12px" }}>
            <Grid item xs={12} lg={9}>
              <Grid container>
                <SchemeData name="Tenure" value={`${payload.tenure} Years`} />
                <SchemeData
                  name="Withdrawal Amount"
                  value={convertToInr(payload.withdrawalAmount)}
                />
                <SchemeData
                  name="SWP Start Date"
                  value={convertDateToIndian(payload.swpStartDate)}
                />
                <SchemeData
                  name="SWP End Date"
                  value={convertDateToIndian(payload.swpEndDate)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
};
